export default {
  newOrdersNumber: {
    id: 'bo_sellers-orders-sub_views-new_orders_number',
    defaultMessage: `{orderCount} new {orderCount, plural,
      one {order}
      other {orders}
    } `,
  },
  pendingOrdersNumber: {
    id: 'bo_sellers-orders-sub_views-pending_orders_number',
    defaultMessage: `{orderCount} pending {orderCount, plural,
      one {order}
      other {orders}
    } `,
  },
  needingResponseOrdersNumber: {
    id: 'bo_sellers-orders-sub_views-needing_response_orders_number',
    defaultMessage: `{orderCount} needing response {orderCount, plural,
    one {order}
    other {orders}
  } `,
  },
  allOrdersNumber: {
    id: 'bo_sellers-orders-sub_views-all_orders_number',
    defaultMessage: `{orderCount} {orderCount, plural,
      one {order}
      other {orders}
    } `,
  },
} as const
